__turbopack_context__.v({
  "dot": "SR7scW_dot",
  "filtersWrapper": "SR7scW_filtersWrapper",
  "itemsWrapper": "SR7scW_itemsWrapper",
  "leadDescription": "SR7scW_leadDescription",
  "numberOfSubcategories": "SR7scW_numberOfSubcategories",
  "previousButton": "SR7scW_previousButton",
  "subcategoriesTitleWrapper": "SR7scW_subcategoriesTitleWrapper",
  "subcategoriesWrapper": "SR7scW_subcategoriesWrapper",
  "subcategoryItem": "SR7scW_subcategoryItem",
  "subcategoryName": "SR7scW_subcategoryName",
  "subcategoryNameActive": "SR7scW_subcategoryNameActive",
});
